var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExchange(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.471,
    height: 19.741,
    viewBox: "0 0 18.471 19.741",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "exchange",
    transform: "translate(-14.725 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36396",
    "data-name": "Group 36396",
    transform: "translate(14.725 5.793)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36395",
    "data-name": "Group 36395",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40542",
    "data-name": "Path 40542",
    d: "M18.8,134.325a4.08,4.08,0,1,0,4.084,4.08A4.08,4.08,0,0,0,18.8,134.325Zm0,3.649a1.417,1.417,0,0,1,1.419,1.419,1.391,1.391,0,0,1-1,1.354v.129a.433.433,0,0,1-.431.436.429.429,0,0,1-.431-.427v-.142a1.428,1.428,0,0,1-.97-1.346.431.431,0,0,1,.863,0,.556.556,0,0,0,1.113,0,.559.559,0,0,0-.556-.561,1.416,1.416,0,0,1-.449-2.76v-.367a.431.431,0,0,1,.863,0v.354a1.387,1.387,0,0,1,1,1.354.431.431,0,1,1-.863,0,.556.556,0,1,0-.556.556Z",
    transform: "translate(-14.725 -134.325)",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_36398",
    "data-name": "Group 36398",
    transform: "translate(25.037 5.797)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36397",
    "data-name": "Group 36397"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40543",
    "data-name": "Path 40543",
    d: "M257.9,134.425a4.08,4.08,0,1,0,4.08,4.08A4.08,4.08,0,0,0,257.9,134.425Zm1,2.652h.457a.431.431,0,1,1,0,.863h-.457a1.545,1.545,0,0,1-.436.763,1.694,1.694,0,0,1-.957.479l1.315,1.246,0,0a.43.43,0,0,1-.6.621l-2.087-1.975a.428.428,0,0,1-.134-.311.434.434,0,0,1,.431-.44h.832a.826.826,0,0,0,.582-.237,1.282,1.282,0,0,0,.116-.151h-1.531a.431.431,0,1,1,0-.863h1.531a.868.868,0,0,0-.7-.388h-.832a.431.431,0,1,1,0-.863h2.92a.431.431,0,1,1,0,.863h-.617A2.105,2.105,0,0,1,258.905,137.077Z",
    transform: "translate(-253.825 -134.425)",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_36400",
    "data-name": "Group 36400",
    transform: "translate(17.752 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36399",
    "data-name": "Group 36399",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40544",
    "data-name": "Path 40544",
    d: "M96.323,1.838,94.607.126a.429.429,0,0,0-.608,0,.44.44,0,0,0,0,.617l.975.979H87.293a2.364,2.364,0,0,0-2.368,2.359.422.422,0,0,0,.427.423h0a.427.427,0,0,0,.431-.418v0a1.5,1.5,0,0,1,1.5-1.5h7.685L94,3.55a.43.43,0,0,0,.608.608l1.716-1.708A.435.435,0,0,0,96.323,1.838Z",
    transform: "translate(-84.925 0)",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_36402",
    "data-name": "Group 36402",
    transform: "translate(18.648 15.242)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36401",
    "data-name": "Group 36401",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40545",
    "data-name": "Path 40545",
    d: "M116.8,353.423a.428.428,0,0,0-.436.418v0a1.5,1.5,0,0,1-1.5,1.5h-7.685l.975-.966a.428.428,0,0,0,0-.6l0,0a.429.429,0,0,0-.608,0l-1.716,1.708a.435.435,0,0,0,0,.612l1.716,1.708a.429.429,0,0,0,.608,0,.44.44,0,0,0,0-.617l-.975-.975h7.681a2.364,2.364,0,0,0,2.368-2.359A.427.427,0,0,0,116.8,353.423Z",
    transform: "translate(-105.7 -353.423)",
    fill: "currentColor"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchange);
export default __webpack_public_path__ + "static/media/exchange.41b6b3b6180c38024119069bd72d17da.svg";
export { ForwardRef as ReactComponent };